import { makeStyles } from '@material-ui/core/styles';
import { getLargeDrawerPaperStyles } from 'UI/constants/styles';
import { flexAlignCenterFlexEnd, flexAlignCenterJustifyCenter } from 'UI/utils/styles';

export const useStyles = makeStyles(
  theme => ({
    layout: {
      margin: 0
    },
    drawerContainer: {
      padding: 0,
      overflowY: 'auto',
      flexGrow: 1
    },
    drawerPanel: {
      ...getLargeDrawerPaperStyles(theme)
    },
    circularProgressContainer: {
      ...flexAlignCenterJustifyCenter,
      height: '100%'
    },
    gridContainer: {
      width: '80%'
    },
    closeIconContainer: {
      ...flexAlignCenterFlexEnd,
      backgroundColor: theme.palette.grey[50],
      padding: theme.spacing(2)
    }
  }),
  { classNamePrefix: 'FPQuickview' }
);
